const CheckBox = ({
  id,
  name,
  label,
  checked = false,
  onChange,
  required = false,
  className = "",
  labelClassName = "",
}) => {
  return (
    <div className="space-x-2 pt-4">
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        required={required}
        className={`checkbox-input ${className}`}
      />

      {label && (
        <label
          htmlFor={id}
          className={`secondry-lable text-sm cursor-pointer ${labelClassName}`}
        >
          {label}
        </label>
      )}
    </div>
  );
};

export default CheckBox;
